import { render, staticRenderFns } from "./TradingVue.vue?vue&type=template&id=235c0ade&"
import script from "./TradingVue.vue?vue&type=script&lang=js&"
export * from "./TradingVue.vue?vue&type=script&lang=js&"
import style0 from "./TradingVue.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/bsjung/work/xtc/trading-chart-js/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('235c0ade')) {
      api.createRecord('235c0ade', component.options)
    } else {
      api.reload('235c0ade', component.options)
    }
    module.hot.accept("./TradingVue.vue?vue&type=template&id=235c0ade&", function () {
      api.rerender('235c0ade', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/TradingVue.vue"
export default component.exports